// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StoreRouteImport } from './routes/store'
import { Route as StaffRouteImport } from './routes/staff'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MinistryPartnershipRouteImport } from './routes/ministry-partnership'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FamilyCapitalSystemRouteImport } from './routes/family-capital-system'
import { Route as DisclosuresRouteImport } from './routes/disclosures'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConsoleRouteImport } from './routes/console'
import { Route as ClientRouteImport } from './routes/client'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as BookRouteImport } from './routes/book'
import { Route as AgentRouteImport } from './routes/agent'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AcademyRouteImport } from './routes/academy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R500RouteImport } from './routes/500'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ToolsRetirementRouteImport } from './routes/tools.retirement'
import { Route as ToolsLegacyScoreRouteImport } from './routes/tools.legacy-score'
import { Route as ToolsFamilySnapshotRouteImport } from './routes/tools.family-snapshot'
import { Route as ToolsEstateRouteImport } from './routes/tools.estate'
import { Route as ToolsDimeRouteImport } from './routes/tools.dime'
import { Route as ToolsCompoundRouteImport } from './routes/tools.compound'
import { Route as SettingsPrivacyRouteImport } from './routes/settings.privacy'
import { Route as StoreIndexRouteImport } from './routes/store.index'
import { Route as StoreLibraryRouteImport } from './routes/store.library'
import { Route as StoreCartRouteImport } from './routes/store.cart'
import { Route as StaffTasksRouteImport } from './routes/staff.tasks'
import { Route as StaffMessagesRouteImport } from './routes/staff.messages'
import { Route as StaffLeadsRouteImport } from './routes/staff.leads'
import { Route as StaffDocumentsRouteImport } from './routes/staff.documents'
import { Route as StaffAppointmentsRouteImport } from './routes/staff.appointments'
import { Route as ClientVaultRouteImport } from './routes/client.vault'
import { Route as ClientSnapshotRouteImport } from './routes/client.snapshot'
import { Route as ClientSettingsRouteImport } from './routes/client.settings'
import { Route as ClientPoliciesRouteImport } from './routes/client.policies'
import { Route as ClientMessagesRouteImport } from './routes/client.messages'
import { Route as ClientLibraryRouteImport } from './routes/client.library'
import { Route as ClientGoalsRouteImport } from './routes/client.goals'
import { Route as ClientEducationRouteImport } from './routes/client.education'
import { Route as ClientCalculatorsRouteImport } from './routes/client.calculators'
import { Route as ClientAppointmentsRouteImport } from './routes/client.appointments'
import { Route as ClientAnnouncementsRouteImport } from './routes/client.announcements'
import { Route as CareersApplyRouteImport } from './routes/careers.apply'
import { Route as AgentUnaRouteImport } from './routes/agent.una'
import { Route as AgentTrainingRouteImport } from './routes/agent.training'
import { Route as AgentTeamRouteImport } from './routes/agent.team'
import { Route as AgentSettingsRouteImport } from './routes/agent.settings'
import { Route as AgentResourcesRouteImport } from './routes/agent.resources'
import { Route as AgentReferralsRouteImport } from './routes/agent.referrals'
import { Route as AgentProtocolRouteImport } from './routes/agent.protocol'
import { Route as AgentPipelineRouteImport } from './routes/agent.pipeline'
import { Route as AgentMessagesRouteImport } from './routes/agent.messages'
import { Route as AgentLeadsRouteImport } from './routes/agent.leads'
import { Route as AgentCommissionsRouteImport } from './routes/agent.commissions'
import { Route as AgentClientsRouteImport } from './routes/agent.clients'
import { Route as AgentAvailabilityRouteImport } from './routes/agent.availability'
import { Route as AgentAnnouncementsRouteImport } from './routes/agent.announcements'
import { Route as AdminWhitelistRouteImport } from './routes/admin.whitelist'
import { Route as AdminTrainingRouteImport } from './routes/admin.training'
import { Route as AdminStoreRouteImport } from './routes/admin.store'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminRenewalsRouteImport } from './routes/admin.renewals'
import { Route as AdminPoliciesRouteImport } from './routes/admin.policies'
import { Route as AdminObservabilityRouteImport } from './routes/admin.observability'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as AdminLegalRouteImport } from './routes/admin.legal'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AdminApplicationsRouteImport } from './routes/admin.applications'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as AdminAgentsRouteImport } from './routes/admin.agents'
import { Route as AdminActivityRouteImport } from './routes/admin.activity'
import { Route as AcademyIndexRouteImport } from './routes/academy.index'
import { Route as AcademyLibraryRouteImport } from './routes/academy.library'
import { Route as AcademyGlossaryRouteImport } from './routes/academy.glossary'
import { Route as AcademyAskRouteImport } from './routes/academy.ask'
import { Route as ToolsLegacyScoreIndexRouteImport } from './routes/tools.legacy-score.index'
import { Route as ToolsLegacyScoreAssessRouteImport } from './routes/tools.legacy-score.assess'
import { Route as ToolsFamilySnapshotIndexRouteImport } from './routes/tools.family-snapshot.index'
import { Route as StoreProductsSlugRouteImport } from './routes/store.products.$slug'
import { Route as StoreCheckoutSuccessRouteImport } from './routes/store.checkout.success'
import { Route as StoreCheckoutCancelRouteImport } from './routes/store.checkout.cancel'
import { Route as StoreAgreementOrderIdRouteImport } from './routes/store.agreement.$orderId'
import { Route as StoreLibraryOrdersRouteImport } from './routes/store.library.orders'
import { Route as ClientVaultShareRouteImport } from './routes/client.vault.share'
import { Route as ClientPoliciesPolicyIdRouteImport } from './routes/client.policies.$policyId'
import { Route as CareersApplyConfirmationRouteImport } from './routes/careers.apply.confirmation'
import { Route as AgentUnaIdRouteImport } from './routes/agent.una.$id'
import { Route as AdminStoreOrdersRouteImport } from './routes/admin.store.orders'
import { Route as AcademyTracksSlugRouteImport } from './routes/academy.tracks.$slug'
import { Route as AcademyResourcesSlugRouteImport } from './routes/academy.resources.$slug'
import { Route as AcademyLessonsLessonSlugRouteImport } from './routes/academy.lessons.$lessonSlug'
import { Route as AcademyGlossarySlugRouteImport } from './routes/academy.glossary.$slug'
import { Route as AcademyAskIdRouteImport } from './routes/academy.ask.$id'
import { Route as ToolsLegacyScoreResultTokenRouteImport } from './routes/tools.legacy-score.result.$token'
import { Route as ToolsFamilySnapshotResultTokenRouteImport } from './routes/tools.family-snapshot.result.$token'
import { Route as AdminStoreProductsIdRouteImport } from './routes/admin.store.products.$id'
import { Route as AcademyTracksTrackSlugLessonsLessonSlugRouteImport } from './routes/academy.tracks.$trackSlug.lessons.$lessonSlug'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StoreRoute = StoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => rootRouteImport
          })
const StaffRoute = StaffRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => rootRouteImport
          })
const SolutionsRoute = SolutionsRouteImport.update({
            id: '/solutions',path: '/solutions',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MinistryPartnershipRoute = MinistryPartnershipRouteImport.update({
            id: '/ministry-partnership',path: '/ministry-partnership',getParentRoute: () => rootRouteImport
          })
const MembershipRoute = MembershipRouteImport.update({
            id: '/membership',path: '/membership',getParentRoute: () => rootRouteImport
          })
const MaintenanceRoute = MaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FamilyCapitalSystemRoute = FamilyCapitalSystemRouteImport.update({
            id: '/family-capital-system',path: '/family-capital-system',getParentRoute: () => rootRouteImport
          })
const DisclosuresRoute = DisclosuresRouteImport.update({
            id: '/disclosures',path: '/disclosures',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConsoleRoute = ConsoleRouteImport.update({
            id: '/console',path: '/console',getParentRoute: () => rootRouteImport
          })
const ClientRoute = ClientRouteImport.update({
            id: '/client',path: '/client',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const AgentRoute = AgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AcademyRoute = AcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const R500Route = R500RouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ToolsRetirementRoute = ToolsRetirementRouteImport.update({
            id: '/tools/retirement',path: '/tools/retirement',getParentRoute: () => rootRouteImport
          })
const ToolsLegacyScoreRoute = ToolsLegacyScoreRouteImport.update({
            id: '/tools/legacy-score',path: '/tools/legacy-score',getParentRoute: () => rootRouteImport
          })
const ToolsFamilySnapshotRoute = ToolsFamilySnapshotRouteImport.update({
            id: '/tools/family-snapshot',path: '/tools/family-snapshot',getParentRoute: () => rootRouteImport
          })
const ToolsEstateRoute = ToolsEstateRouteImport.update({
            id: '/tools/estate',path: '/tools/estate',getParentRoute: () => rootRouteImport
          })
const ToolsDimeRoute = ToolsDimeRouteImport.update({
            id: '/tools/dime',path: '/tools/dime',getParentRoute: () => rootRouteImport
          })
const ToolsCompoundRoute = ToolsCompoundRouteImport.update({
            id: '/tools/compound',path: '/tools/compound',getParentRoute: () => rootRouteImport
          })
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
            id: '/settings/privacy',path: '/settings/privacy',getParentRoute: () => rootRouteImport
          })
const StoreIndexRoute = StoreIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StoreRoute
          })
const StoreLibraryRoute = StoreLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => StoreRoute
          })
const StoreCartRoute = StoreCartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => StoreRoute
          })
const StaffTasksRoute = StaffTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => StaffRoute
          })
const StaffMessagesRoute = StaffMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => StaffRoute
          })
const StaffLeadsRoute = StaffLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => StaffRoute
          })
const StaffDocumentsRoute = StaffDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => StaffRoute
          })
const StaffAppointmentsRoute = StaffAppointmentsRouteImport.update({
            id: '/appointments',path: '/appointments',getParentRoute: () => StaffRoute
          })
const ClientVaultRoute = ClientVaultRouteImport.update({
            id: '/vault',path: '/vault',getParentRoute: () => ClientRoute
          })
const ClientSnapshotRoute = ClientSnapshotRouteImport.update({
            id: '/snapshot',path: '/snapshot',getParentRoute: () => ClientRoute
          })
const ClientSettingsRoute = ClientSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ClientRoute
          })
const ClientPoliciesRoute = ClientPoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => ClientRoute
          })
const ClientMessagesRoute = ClientMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => ClientRoute
          })
const ClientLibraryRoute = ClientLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => ClientRoute
          })
const ClientGoalsRoute = ClientGoalsRouteImport.update({
            id: '/goals',path: '/goals',getParentRoute: () => ClientRoute
          })
const ClientEducationRoute = ClientEducationRouteImport.update({
            id: '/education',path: '/education',getParentRoute: () => ClientRoute
          })
const ClientCalculatorsRoute = ClientCalculatorsRouteImport.update({
            id: '/calculators',path: '/calculators',getParentRoute: () => ClientRoute
          })
const ClientAppointmentsRoute = ClientAppointmentsRouteImport.update({
            id: '/appointments',path: '/appointments',getParentRoute: () => ClientRoute
          })
const ClientAnnouncementsRoute = ClientAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => ClientRoute
          })
const CareersApplyRoute = CareersApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => CareersRoute
          })
const AgentUnaRoute = AgentUnaRouteImport.update({
            id: '/una',path: '/una',getParentRoute: () => AgentRoute
          })
const AgentTrainingRoute = AgentTrainingRouteImport.update({
            id: '/training',path: '/training',getParentRoute: () => AgentRoute
          })
const AgentTeamRoute = AgentTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AgentRoute
          })
const AgentSettingsRoute = AgentSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AgentRoute
          })
const AgentResourcesRoute = AgentResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => AgentRoute
          })
const AgentReferralsRoute = AgentReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AgentRoute
          })
const AgentProtocolRoute = AgentProtocolRouteImport.update({
            id: '/protocol',path: '/protocol',getParentRoute: () => AgentRoute
          })
const AgentPipelineRoute = AgentPipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => AgentRoute
          })
const AgentMessagesRoute = AgentMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AgentRoute
          })
const AgentLeadsRoute = AgentLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AgentRoute
          })
const AgentCommissionsRoute = AgentCommissionsRouteImport.update({
            id: '/commissions',path: '/commissions',getParentRoute: () => AgentRoute
          })
const AgentClientsRoute = AgentClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AgentRoute
          })
const AgentAvailabilityRoute = AgentAvailabilityRouteImport.update({
            id: '/availability',path: '/availability',getParentRoute: () => AgentRoute
          })
const AgentAnnouncementsRoute = AgentAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AgentRoute
          })
const AdminWhitelistRoute = AdminWhitelistRouteImport.update({
            id: '/whitelist',path: '/whitelist',getParentRoute: () => AdminRoute
          })
const AdminTrainingRoute = AdminTrainingRouteImport.update({
            id: '/training',path: '/training',getParentRoute: () => AdminRoute
          })
const AdminStoreRoute = AdminStoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminRenewalsRoute = AdminRenewalsRouteImport.update({
            id: '/renewals',path: '/renewals',getParentRoute: () => AdminRoute
          })
const AdminPoliciesRoute = AdminPoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => AdminRoute
          })
const AdminObservabilityRoute = AdminObservabilityRouteImport.update({
            id: '/observability',path: '/observability',getParentRoute: () => AdminRoute
          })
const AdminMessagesRoute = AdminMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AdminRoute
          })
const AdminLegalRoute = AdminLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => AdminRoute
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AdminRoute
          })
const AdminClientsRoute = AdminClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AdminRoute
          })
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => AdminRoute
          })
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AdminRoute
          })
const AdminAgentsRoute = AdminAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AdminRoute
          })
const AdminActivityRoute = AdminActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AdminRoute
          })
const AcademyIndexRoute = AcademyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AcademyRoute
          })
const AcademyLibraryRoute = AcademyLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AcademyRoute
          })
const AcademyGlossaryRoute = AcademyGlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => AcademyRoute
          })
const AcademyAskRoute = AcademyAskRouteImport.update({
            id: '/ask',path: '/ask',getParentRoute: () => AcademyRoute
          })
const ToolsLegacyScoreIndexRoute = ToolsLegacyScoreIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsLegacyScoreRoute
          })
const ToolsLegacyScoreAssessRoute = ToolsLegacyScoreAssessRouteImport.update({
            id: '/assess',path: '/assess',getParentRoute: () => ToolsLegacyScoreRoute
          })
const ToolsFamilySnapshotIndexRoute = ToolsFamilySnapshotIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsFamilySnapshotRoute
          })
const StoreProductsSlugRoute = StoreProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => StoreRoute
          })
const StoreCheckoutSuccessRoute = StoreCheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => StoreRoute
          })
const StoreCheckoutCancelRoute = StoreCheckoutCancelRouteImport.update({
            id: '/checkout/cancel',path: '/checkout/cancel',getParentRoute: () => StoreRoute
          })
const StoreAgreementOrderIdRoute = StoreAgreementOrderIdRouteImport.update({
            id: '/agreement/$orderId',path: '/agreement/$orderId',getParentRoute: () => StoreRoute
          })
const StoreLibraryOrdersRoute = StoreLibraryOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => StoreLibraryRoute
          })
const ClientVaultShareRoute = ClientVaultShareRouteImport.update({
            id: '/share',path: '/share',getParentRoute: () => ClientVaultRoute
          })
const ClientPoliciesPolicyIdRoute = ClientPoliciesPolicyIdRouteImport.update({
            id: '/$policyId',path: '/$policyId',getParentRoute: () => ClientPoliciesRoute
          })
const CareersApplyConfirmationRoute = CareersApplyConfirmationRouteImport.update({
            id: '/confirmation',path: '/confirmation',getParentRoute: () => CareersApplyRoute
          })
const AgentUnaIdRoute = AgentUnaIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AgentUnaRoute
          })
const AdminStoreOrdersRoute = AdminStoreOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminStoreRoute
          })
const AcademyTracksSlugRoute = AcademyTracksSlugRouteImport.update({
            id: '/tracks/$slug',path: '/tracks/$slug',getParentRoute: () => AcademyRoute
          })
const AcademyResourcesSlugRoute = AcademyResourcesSlugRouteImport.update({
            id: '/resources/$slug',path: '/resources/$slug',getParentRoute: () => AcademyRoute
          })
const AcademyLessonsLessonSlugRoute = AcademyLessonsLessonSlugRouteImport.update({
            id: '/lessons/$lessonSlug',path: '/lessons/$lessonSlug',getParentRoute: () => AcademyRoute
          })
const AcademyGlossarySlugRoute = AcademyGlossarySlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AcademyGlossaryRoute
          })
const AcademyAskIdRoute = AcademyAskIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AcademyAskRoute
          })
const ToolsLegacyScoreResultTokenRoute = ToolsLegacyScoreResultTokenRouteImport.update({
            id: '/result/$token',path: '/result/$token',getParentRoute: () => ToolsLegacyScoreRoute
          })
const ToolsFamilySnapshotResultTokenRoute = ToolsFamilySnapshotResultTokenRouteImport.update({
            id: '/result/$token',path: '/result/$token',getParentRoute: () => ToolsFamilySnapshotRoute
          })
const AdminStoreProductsIdRoute = AdminStoreProductsIdRouteImport.update({
            id: '/products/$id',path: '/products/$id',getParentRoute: () => AdminStoreRoute
          })
const AcademyTracksTrackSlugLessonsLessonSlugRoute = AcademyTracksTrackSlugLessonsLessonSlugRouteImport.update({
            id: '/tracks/$trackSlug/lessons/$lessonSlug',path: '/tracks/$trackSlug/lessons/$lessonSlug',getParentRoute: () => AcademyRoute
          })





const AcademyAskRouteChildren = {
  AcademyAskIdRoute: AcademyAskIdRoute
}

const AcademyAskRouteWithChildren = AcademyAskRoute._addFileChildren(AcademyAskRouteChildren)




const AcademyGlossaryRouteChildren = {
  AcademyGlossarySlugRoute: AcademyGlossarySlugRoute
}

const AcademyGlossaryRouteWithChildren = AcademyGlossaryRoute._addFileChildren(AcademyGlossaryRouteChildren)



const AcademyRouteChildren = {
  AcademyAskRoute: AcademyAskRouteWithChildren,AcademyGlossaryRoute: AcademyGlossaryRouteWithChildren,AcademyLibraryRoute: AcademyLibraryRoute,AcademyIndexRoute: AcademyIndexRoute,AcademyLessonsLessonSlugRoute: AcademyLessonsLessonSlugRoute,AcademyResourcesSlugRoute: AcademyResourcesSlugRoute,AcademyTracksSlugRoute: AcademyTracksSlugRoute,AcademyTracksTrackSlugLessonsLessonSlugRoute: AcademyTracksTrackSlugLessonsLessonSlugRoute
}

const AcademyRouteWithChildren = AcademyRoute._addFileChildren(AcademyRouteChildren)




const AdminStoreRouteChildren = {
  AdminStoreOrdersRoute: AdminStoreOrdersRoute,AdminStoreProductsIdRoute: AdminStoreProductsIdRoute
}

const AdminStoreRouteWithChildren = AdminStoreRoute._addFileChildren(AdminStoreRouteChildren)



const AdminRouteChildren = {
  AdminActivityRoute: AdminActivityRoute,AdminAgentsRoute: AdminAgentsRoute,AdminAnnouncementsRoute: AdminAnnouncementsRoute,AdminApplicationsRoute: AdminApplicationsRoute,AdminClientsRoute: AdminClientsRoute,AdminLeadsRoute: AdminLeadsRoute,AdminLegalRoute: AdminLegalRoute,AdminMessagesRoute: AdminMessagesRoute,AdminObservabilityRoute: AdminObservabilityRoute,AdminPoliciesRoute: AdminPoliciesRoute,AdminRenewalsRoute: AdminRenewalsRoute,AdminReportsRoute: AdminReportsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminStoreRoute: AdminStoreRouteWithChildren,AdminTrainingRoute: AdminTrainingRoute,AdminWhitelistRoute: AdminWhitelistRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AgentUnaRouteChildren = {
  AgentUnaIdRoute: AgentUnaIdRoute
}

const AgentUnaRouteWithChildren = AgentUnaRoute._addFileChildren(AgentUnaRouteChildren)



const AgentRouteChildren = {
  AgentAnnouncementsRoute: AgentAnnouncementsRoute,AgentAvailabilityRoute: AgentAvailabilityRoute,AgentClientsRoute: AgentClientsRoute,AgentCommissionsRoute: AgentCommissionsRoute,AgentLeadsRoute: AgentLeadsRoute,AgentMessagesRoute: AgentMessagesRoute,AgentPipelineRoute: AgentPipelineRoute,AgentProtocolRoute: AgentProtocolRoute,AgentReferralsRoute: AgentReferralsRoute,AgentResourcesRoute: AgentResourcesRoute,AgentSettingsRoute: AgentSettingsRoute,AgentTeamRoute: AgentTeamRoute,AgentTrainingRoute: AgentTrainingRoute,AgentUnaRoute: AgentUnaRouteWithChildren
}

const AgentRouteWithChildren = AgentRoute._addFileChildren(AgentRouteChildren)




const CareersApplyRouteChildren = {
  CareersApplyConfirmationRoute: CareersApplyConfirmationRoute
}

const CareersApplyRouteWithChildren = CareersApplyRoute._addFileChildren(CareersApplyRouteChildren)



const CareersRouteChildren = {
  CareersApplyRoute: CareersApplyRouteWithChildren
}

const CareersRouteWithChildren = CareersRoute._addFileChildren(CareersRouteChildren)




const ClientPoliciesRouteChildren = {
  ClientPoliciesPolicyIdRoute: ClientPoliciesPolicyIdRoute
}

const ClientPoliciesRouteWithChildren = ClientPoliciesRoute._addFileChildren(ClientPoliciesRouteChildren)




const ClientVaultRouteChildren = {
  ClientVaultShareRoute: ClientVaultShareRoute
}

const ClientVaultRouteWithChildren = ClientVaultRoute._addFileChildren(ClientVaultRouteChildren)



const ClientRouteChildren = {
  ClientAnnouncementsRoute: ClientAnnouncementsRoute,ClientAppointmentsRoute: ClientAppointmentsRoute,ClientCalculatorsRoute: ClientCalculatorsRoute,ClientEducationRoute: ClientEducationRoute,ClientGoalsRoute: ClientGoalsRoute,ClientLibraryRoute: ClientLibraryRoute,ClientMessagesRoute: ClientMessagesRoute,ClientPoliciesRoute: ClientPoliciesRouteWithChildren,ClientSettingsRoute: ClientSettingsRoute,ClientSnapshotRoute: ClientSnapshotRoute,ClientVaultRoute: ClientVaultRouteWithChildren
}

const ClientRouteWithChildren = ClientRoute._addFileChildren(ClientRouteChildren)




const StaffRouteChildren = {
  StaffAppointmentsRoute: StaffAppointmentsRoute,StaffDocumentsRoute: StaffDocumentsRoute,StaffLeadsRoute: StaffLeadsRoute,StaffMessagesRoute: StaffMessagesRoute,StaffTasksRoute: StaffTasksRoute
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)




const StoreLibraryRouteChildren = {
  StoreLibraryOrdersRoute: StoreLibraryOrdersRoute
}

const StoreLibraryRouteWithChildren = StoreLibraryRoute._addFileChildren(StoreLibraryRouteChildren)



const StoreRouteChildren = {
  StoreCartRoute: StoreCartRoute,StoreLibraryRoute: StoreLibraryRouteWithChildren,StoreIndexRoute: StoreIndexRoute,StoreAgreementOrderIdRoute: StoreAgreementOrderIdRoute,StoreCheckoutCancelRoute: StoreCheckoutCancelRoute,StoreCheckoutSuccessRoute: StoreCheckoutSuccessRoute,StoreProductsSlugRoute: StoreProductsSlugRoute
}

const StoreRouteWithChildren = StoreRoute._addFileChildren(StoreRouteChildren)




const ToolsFamilySnapshotRouteChildren = {
  ToolsFamilySnapshotIndexRoute: ToolsFamilySnapshotIndexRoute,ToolsFamilySnapshotResultTokenRoute: ToolsFamilySnapshotResultTokenRoute
}

const ToolsFamilySnapshotRouteWithChildren = ToolsFamilySnapshotRoute._addFileChildren(ToolsFamilySnapshotRouteChildren)




const ToolsLegacyScoreRouteChildren = {
  ToolsLegacyScoreAssessRoute: ToolsLegacyScoreAssessRoute,ToolsLegacyScoreIndexRoute: ToolsLegacyScoreIndexRoute,ToolsLegacyScoreResultTokenRoute: ToolsLegacyScoreResultTokenRoute
}

const ToolsLegacyScoreRouteWithChildren = ToolsLegacyScoreRoute._addFileChildren(ToolsLegacyScoreRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R500Route: R500Route,AboutRoute: AboutRoute,AcademyRoute: AcademyRouteWithChildren,AccessibilityRoute: AccessibilityRoute,AccountRoute: AccountRoute,AdminRoute: AdminRouteWithChildren,AdminLoginRoute: AdminLoginRoute,AgentRoute: AgentRouteWithChildren,BookRoute: BookRoute,CareersRoute: CareersRouteWithChildren,ClientRoute: ClientRouteWithChildren,ConsoleRoute: ConsoleRoute,ContactRoute: ContactRoute,DisclosuresRoute: DisclosuresRoute,FamilyCapitalSystemRoute: FamilyCapitalSystemRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,MaintenanceRoute: MaintenanceRoute,MembershipRoute: MembershipRoute,MinistryPartnershipRoute: MinistryPartnershipRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,SolutionsRoute: SolutionsRoute,StaffRoute: StaffRouteWithChildren,StoreRoute: StoreRouteWithChildren,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,SettingsPrivacyRoute: SettingsPrivacyRoute,ToolsCompoundRoute: ToolsCompoundRoute,ToolsDimeRoute: ToolsDimeRoute,ToolsEstateRoute: ToolsEstateRoute,ToolsFamilySnapshotRoute: ToolsFamilySnapshotRouteWithChildren,ToolsLegacyScoreRoute: ToolsLegacyScoreRouteWithChildren,ToolsRetirementRoute: ToolsRetirementRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)